import { __read, __spread } from "tslib";
import { PluginPerformanceReport, } from './plugin-performance-report';
var PluginPerformanceObserver = /** @class */ (function () {
    function PluginPerformanceObserver(callback) {
        var _this = this;
        this.callback = callback;
        this.getNodeCounts = function () { return [
            {},
            0,
        ]; };
        this.getPlugins = function () { return []; };
        this.getOptions = function () { return ({}); };
        this.reportCount = 0;
        this.onObserveration = function (entries) {
            var reports = entries
                .getEntriesByName('🦉 ReactEditorView::dispatchTransaction')
                .map(function (entry) {
                var _a;
                return (_a = PluginPerformanceReport.fromEntry(entry)
                    .withCount(++_this.reportCount)
                    .withEntryList(entries)).withNodes.apply(_a, __spread(_this.getNodeCounts())).withPlugins(_this.getPlugins())
                    .withOptions(_this.getOptions())
                    .toJSON();
            });
            reports
                .filter(function (report) { return report.trigger !== 'none'; })
                .forEach(function (report) { return _this.callback(report); });
        };
        this.observer = window.PerformanceObserver
            ? new PerformanceObserver(this.onObserveration)
            : {
                observe: function () { },
                disconnect: function () { },
                takeRecords: function () {
                    return [];
                },
            };
    }
    PluginPerformanceObserver.prototype.withNodeCounts = function (getNodeCounts) {
        this.getNodeCounts = function () {
            var start = performance.now();
            var result = getNodeCounts();
            return [result, performance.now() - start];
        };
        return this;
    };
    PluginPerformanceObserver.prototype.withPlugins = function (getPlugins) {
        this.getPlugins = getPlugins;
        return this;
    };
    PluginPerformanceObserver.prototype.withOptions = function (getOptions) {
        this.getOptions = getOptions;
        return this;
    };
    PluginPerformanceObserver.prototype.observe = function () {
        try {
            this.observer.observe({
                buffered: false,
                type: 'measure',
            });
        }
        catch (err) {
            // Older API implementations do not support the simpler type init
            this.observer.observe({
                entryTypes: ['measure'],
            });
        }
    };
    PluginPerformanceObserver.prototype.disconnect = function () {
        this.observer.disconnect();
    };
    PluginPerformanceObserver.prototype.takeRecords = function () {
        return this.observer.takeRecords();
    };
    return PluginPerformanceObserver;
}());
export { PluginPerformanceObserver };
//# sourceMappingURL=plugin-performance-observer.js.map